import { cn } from '@/lib/utils';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const avatarInitialsVariants = cva(
  'rounded-full flex items-center justify-center font-bold shrink-0',
  {
    variants: {
      size: {
        sm: 'w-8 h-8 text-[10px]',
        md: 'w-9 h-9 text-xs',
        lg: 'w-10 h-10 text-sm',
      },
      variant: {
        muted: 'bg-primary/10 text-primary',
        solid: 'bg-primary text-primary-foreground',
        stacked: 'bg-primary/10 text-primary border-2 border-background',
      },
    },
    defaultVariants: {
      size: 'md',
      variant: 'muted',
    },
  }
);

interface AvatarInitialsProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof avatarInitialsVariants> {
  initials: string;
}

const AvatarInitials = React.forwardRef<HTMLDivElement, AvatarInitialsProps>(
  ({ className, size, variant, initials, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(avatarInitialsVariants({ size, variant }), className)}
      {...props}
    >
      {initials}
    </div>
  )
);
AvatarInitials.displayName = 'AvatarInitials';

export { AvatarInitials, avatarInitialsVariants };
